"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'gdpr' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 5 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'gdpr' });
    }
    ;
    /**
    * @typedef {Object} cookiesBannerUouReviewRequirementsAlertParams
    
    **/
    /**
     * Name: Cookies banner UoU- review requirements alert. Evid: 1092.
     * Event description: The user didn't check the box for the cookie policy requirements and when he tried to save he got the review requirements alert..
    
    
     * @param {cookiesBannerUouReviewRequirementsAlertParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouReviewRequirementsAlert = function (params) {
        return this.bi.log(__assign({ evid: 1092 }, params));
    };
    /**
    * @typedef {Object} gdprUouSiteOwnerReConfirmUouInformationParams
    * @property {string} hashed_mail - hashed uou email
    * @property {string} hashed_phone - hashed uou phone
    * @property {GUID} msid - the site of the request
    * @property {string} request_type - Delete / Get request
    **/
    /**
     * Name: GDPR - UoU - Site Owner Re-Confirm UoU Information. Evid: 805.
     * Event description: The user/site owner click on the 'submit ' button after validate his user  recognition details (phone/email).
    
     * hashed_mail - Type: string. Desc: hashed uou email
     *
     * hashed_phone - Type: string. Desc: hashed uou phone
     *
     * msid - Type: guid. Desc: the site of the request
     *
     * request_type - Type: string. Desc: Delete / Get request
     * @param {gdprUouSiteOwnerReConfirmUouInformationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gdprUouSiteOwnerReConfirmUouInformation = function (params) {
        return this.bi.log(__assign({ evid: 805 }, params));
    };
    /**
    * @typedef {Object} gdprUsersUserGdprFormSubmissionFailedParams
    * @property {DateTime} account_creation_date - user information
    * @property {string} error_reason - failure reason
    * @property {string} hashed_first_name - user information
    * @property {string} hashed_last_name - user information
    * @property {string} hashed_mail - email account that is visible to the user
    * @property {string} hashed_phone - user information
    * @property {boolean} is_file_loaded - user information
    * @property {boolean} is_premium - user information
    * @property {boolean} is_site_has_contact_form - user information
    * @property {DateTime} last_site_edit_date - user information
    * @property {string} request_type - Get / Delete
    * @property {string} site_contact_hashed_mail - user information
    * @property {Url} site_url - user information
    **/
    /**
     * Name: GDPR - Users - User GDPR Form Submission Failed. Evid: 813.
     * Event description: GDPR form failed to submit ..
    
     * account_creation_date - Type: datetime. Desc: user information
     *
     * error_reason - Type: string. Desc: failure reason
     *
     * hashed_first_name - Type: string. Desc: user information
     *
     * hashed_last_name - Type: string. Desc: user information
     *
     * hashed_mail - Type: string. Desc: email account that is visible to the user
     *
     * hashed_phone - Type: string. Desc: user information
     *
     * is_file_loaded - Type: bool. Desc: user information
     *
     * is_premium - Type: bool. Desc: user information
     *
     * is_site_has_contact_form - Type: bool. Desc: user information
     *
     * last_site_edit_date - Type: datetime. Desc: user information
     *
     * request_type - Type: string. Desc: Get / Delete
     *
     * site_contact_hashed_mail - Type: string. Desc: user information
     *
     * site_url - Type: url. Desc: user information
     * @param {gdprUsersUserGdprFormSubmissionFailedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gdprUsersUserGdprFormSubmissionFailed = function (params) {
        return this.bi.log(__assign({ evid: 813 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouUserWithPopUpCtaParams
    * @property {string} action - right click / left click
    * @property {string} pop_up_type - Privacy Policy link is missing / Reset cookie consent log / something went wrong / Cookie banner is published / Hide cookie banner / Your cookie policy is now live / Disable customized cookie banner / Enable wix standard cookie banner/  Disable wix standard cookie consent banner / sure you want to leave
    **/
    /**
     * Name: Cookies banner UoU- User with pop-up CTA. Evid: 1081.
     * Event description: User interaction with the different pop-ups.
    
     * action - Type: string. Desc: right click / left click
     *
     * pop_up_type - Type: string. Desc: Privacy Policy link is missing / Reset cookie consent log / something went wrong / Cookie banner is published / Hide cookie banner / Your cookie policy is now live / Disable customized cookie banner / Enable wix standard cookie banner/  Disable wix standard cookie consent banner / sure you want to leave
     * @param {cookiesBannerUouUserWithPopUpCtaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouUserWithPopUpCta = function (params) {
        return this.bi.log(__assign({ evid: 1081 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouExportConsentLogCtaParams
    * @property {string} action - close / Export / cancel
    * @property {string} time_option - 7 days / 4 weeks / 3 months / 6 months
    **/
    /**
     * Name: Cookies banner UoU- Export consent log CTA. Evid: 1089.
     * Event description: User interaction with Export consent log pop-up.
    
     * action - Type: string. Desc: close / Export / cancel
     *
     * time_option - Type: string. Desc: 7 days / 4 weeks / 3 months / 6 months
     * @param {cookiesBannerUouExportConsentLogCtaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouExportConsentLogCta = function (params) {
        return this.bi.log(__assign({ evid: 1089 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouAddADoNotSellDateLinkClickParams
    
    **/
    /**
     * Name: Cookies banner UoU- Add a ‘Do Not Sell Date’ link click. Evid: 1084.
     * Event description: The user clicked Add a ‘Do Not Sell Date’ link in the editor.
    
    
     * @param {cookiesBannerUouAddADoNotSellDateLinkClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouAddADoNotSellDateLinkClick = function (params) {
        return this.bi.log(__assign({ evid: 1084 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerCtaParams
    * @property {string} action - accept/settings/dismiss/read_policy/render
    * @property {Url} url - url
    **/
    /**
     * Name: Cookies banner- CTA. Evid: 814.
     * Event description: User interaction with the banner.
    
     * action - Type: string. Desc: accept/settings/dismiss/read_policy/render
     *
     * url - Type: url. Desc: url
     * @param {cookiesBannerCtaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerCta = function (params) {
        return this.bi.log(__assign({ evid: 814 }, params));
    };
    /**
    * @typedef {Object} gdprUouSiteOwnerOpenPrivacyGdprTabParams
    * @property {GUID} msid - the site where the request asked
    **/
    /**
     * Name: GDPR - UoU - Site Owner Open 'Privacy & GDPR' Tab. Evid: 801.
     * Event description: The user/site owner clicked on the  left menu bar 'Privacy & GDPR' Tab.
    
     * msid - Type: guid. Desc: the site where the request asked
     * @param {gdprUouSiteOwnerOpenPrivacyGdprTabParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gdprUouSiteOwnerOpenPrivacyGdprTab = function (params) {
        return this.bi.log(__assign({ evid: 801 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouUserHoverOverTooltipParams
    * @property {string} name - consent button text / setting button text / privacy policy text / page on my site / external web address / audience / save button text /  essential cookies/ marketing cookies / functional cookies / analytics cookies
    **/
    /**
     * Name: Cookies banner UoU- User hover over tooltip. Evid: 1075.
     * Event description: User interaction with the different i icons in the privacy & cookie flow.
    
     * name - Type: string. Desc: consent button text / setting button text / privacy policy text / page on my site / external web address / audience / save button text /  essential cookies/ marketing cookies / functional cookies / analytics cookies
     * @param {cookiesBannerUouUserHoverOverTooltipParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouUserHoverOverTooltip = function (params) {
        return this.bi.log(__assign({ evid: 1075 }, params));
    };
    /**
    * @typedef {Object} gdprUouSiteOwnerInsertUouInformationParams
    * @property {string} hashed_mail - hashed uou email
    * @property {string} hashed_phone - hashed uou phone
    * @property {GUID} msid - the site of the request
    * @property {string} request_type - Delete / Get request
    **/
    /**
     * Name: GDPR - UoU - Site Owner Insert UoU Information. Evid: 804.
     * Event description: The user/site owner insert at least one of the required recognition details (phone/email) and submit the request to continue the form.
    
     * hashed_mail - Type: string. Desc: hashed uou email
     *
     * hashed_phone - Type: string. Desc: hashed uou phone
     *
     * msid - Type: guid. Desc: the site of the request
     *
     * request_type - Type: string. Desc: Delete / Get request
     * @param {gdprUouSiteOwnerInsertUouInformationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gdprUouSiteOwnerInsertUouInformation = function (params) {
        return this.bi.log(__assign({ evid: 804 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerSettingsWindowCtaParams
    * @property {string} action - save/dismiss/toggle/read_policy
    * @property {boolean} toggle - (optional) on/off
    * @property {Url} url - url
    **/
    /**
     * Name: Cookies banner- settings window CTA. Evid: 815.
     * Event description: User interaction with the cookie settings window.
    
     * action - Type: string. Desc: save/dismiss/toggle/read_policy
     *
     * toggle - Type: bool. Desc: (optional) on/off
     *
     * url - Type: url. Desc: url
     * @param {cookiesBannerSettingsWindowCtaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerSettingsWindowCta = function (params) {
        return this.bi.log(__assign({ evid: 815 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerPrivacyPolicyClickedParams
    * @property {string} policy - cookie/ccpa
    * @property {Url} url - url
    **/
    /**
     * Name: Cookies banner- privacy policy clicked. Evid: 816.
     * Event description: The user clicked on one of the policies descriptions in the privacy policy.
    
     * policy - Type: string. Desc: cookie/ccpa
     *
     * url - Type: url. Desc: url
     * @param {cookiesBannerPrivacyPolicyClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerPrivacyPolicyClicked = function (params) {
        return this.bi.log(__assign({ evid: 816 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouUserClickOnVisitorDataOptionParams
    * @property {string} action - data request / consent log
    **/
    /**
     * Name: Cookies banner UoU- User click on visitor data option. Evid: 1074.
     * Event description: The user clicked one of the visitor data options.
    
     * action - Type: string. Desc: data request / consent log
     * @param {cookiesBannerUouUserClickOnVisitorDataOptionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouUserClickOnVisitorDataOption = function (params) {
        return this.bi.log(__assign({ evid: 1074 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouUserConsentLogCtaParams
    * @property {string} action - learn more/ learn how/ download
    **/
    /**
     * Name: Cookies banner UoU- User consent log CTA. Evid: 1088.
     * Event description: User interaction with the consent log options.
    
     * action - Type: string. Desc: learn more/ learn how/ download
     * @param {cookiesBannerUouUserConsentLogCtaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouUserConsentLogCta = function (params) {
        return this.bi.log(__assign({ evid: 1088 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouSearchMembersByIdParams
    * @property {string} member_id_filled - member id
    **/
    /**
     * Name: Cookies banner UoU- Search members by ID. Evid: 1091.
     * Event description: The user clicked to search site members by ID.
    
     * member_id_filled - Type: string. Desc: member id
     * @param {cookiesBannerUouSearchMembersByIdParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouSearchMembersById = function (params) {
        return this.bi.log(__assign({ evid: 1091 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouCookieConsentBannerGetStartedClickParams
    * @property {string} action - get started / edit
    **/
    /**
     * Name: Cookies banner UoU- cookie consent banner get started Click. Evid: 1076.
     * Event description: The user clicked the option to display the banner on his site.
    
     * action - Type: string. Desc: get started / edit
     * @param {cookiesBannerUouCookieConsentBannerGetStartedClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouCookieConsentBannerGetStartedClick = function (params) {
        return this.bi.log(__assign({ evid: 1076 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouSavePublishClickParams
    * @property {string} analytics_cookies_text - changed / not changed
    * @property {string} audience - all visitors
    * @property {string} banner_color - dark/light
    * @property {string} consent_button_text - changed / not changed
    * @property {string} cookie_status - off / standard/ custom
    * @property {string} essential_cookies_text - changed / not changed
    * @property {string} functional_cookies_text - changed / not changed
    * @property {string} general_text - changed / not changed
    * @property {string} link_option - Page On My Site / external Web Address
    * @property {string} marketing_cookies_text - changed / not changed
    * @property {string} privacy_policy_link_text - changed / not changed
    * @property {string} save_button_text - changed / not changed
    * @property {string} settings_button_text - changed / not changed
    * @property {Url} url_privacy_policy - url
    **/
    /**
     * Name: Cookies banner UoU- Save & Publish click. Evid: 1080.
     * Event description: User click to save and publish his cookies banner setting.
    
     * analytics_cookies_text - Type: string. Desc: changed / not changed
     *
     * audience - Type: string. Desc: all visitors
     *
     * banner_color - Type: string. Desc: dark/light
     *
     * consent_button_text - Type: string. Desc: changed / not changed
     *
     * cookie_status - Type: string. Desc: off / standard/ custom
     *
     * essential_cookies_text - Type: string. Desc: changed / not changed
     *
     * functional_cookies_text - Type: string. Desc: changed / not changed
     *
     * general_text - Type: string. Desc: changed / not changed
     *
     * link_option - Type: string. Desc: Page On My Site / external Web Address
     *
     * marketing_cookies_text - Type: string. Desc: changed / not changed
     *
     * privacy_policy_link_text - Type: string. Desc: changed / not changed
     *
     * save_button_text - Type: string. Desc: changed / not changed
     *
     * settings_button_text - Type: string. Desc: changed / not changed
     *
     * url_privacy_policy - Type: url. Desc: url
     * @param {cookiesBannerUouSavePublishClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouSavePublishClick = function (params) {
        return this.bi.log(__assign({ evid: 1080 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouUouClickOnDoNotSellMyDataLinkParams
    
    **/
    /**
     * Name: Cookies banner UoU- UoU click on ‘Do Not Sell my Data’ link. Evid: 1085.
     * Event description: UoU clicked the 'Do Not Sell my Data’ link in a user site.
    
    
     * @param {cookiesBannerUouUouClickOnDoNotSellMyDataLinkParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouUouClickOnDoNotSellMyDataLink = function (params) {
        return this.bi.log(__assign({ evid: 1085 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouUserClickedOnTheGeneralXButtonParams
    
    **/
    /**
     * Name: Cookies banner UoU- User clicked on the general X button. Evid: 1079.
     * Event description: The user clicked to close the privacy & cookies options.
    
    
     * @param {cookiesBannerUouUserClickedOnTheGeneralXButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouUserClickedOnTheGeneralXButton = function (params) {
        return this.bi.log(__assign({ evid: 1079 }, params));
    };
    /**
    * @typedef {Object} gdprUsersUserOpenedTheGdprFormParams
    * @property {string} hashed_mail - email account that is visible to the user
    * @property {string} request_type - Get / Delete
    **/
    /**
     * Name: GDPR - Users - User Opened The GDPR Form. Evid: 810.
     * Event description: GDPR form page URL is available and loaded successfully to Wix user..
    
     * hashed_mail - Type: string. Desc: email account that is visible to the user
     *
     * request_type - Type: string. Desc: Get / Delete
     * @param {gdprUsersUserOpenedTheGdprFormParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gdprUsersUserOpenedTheGdprForm = function (params) {
        return this.bi.log(__assign({ evid: 810 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerSettingPageOptOutConfirmationParams
    * @property {string} action - cancel/ok/dismiss
    * @property {string} policy - cookie/ccpa
    * @property {Url} url - url
    **/
    /**
     * Name: Cookies banner- setting page opt out confirmation. Evid: 818.
     * Event description: User interaction with opt-out confirmation in the setting page.
    
     * action - Type: string. Desc: cancel/ok/dismiss
     *
     * policy - Type: string. Desc: cookie/ccpa
     *
     * url - Type: url. Desc: url
     * @param {cookiesBannerSettingPageOptOutConfirmationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerSettingPageOptOutConfirmation = function (params) {
        return this.bi.log(__assign({ evid: 818 }, params));
    };
    /**
    * @typedef {Object} gdprUouSiteOwnerSelectRequestTypeParams
    * @property {GUID} msid - the site of the request
    * @property {string} origin - the clicked page component
    * @property {string} request_type - Delete / Get request
    **/
    /**
     * Name: GDPR - UoU - Site Owner Select Request Type. Evid: 803.
     * Event description: The user/site owner select between 'get' or 'delete' request type and click continue the complete the rest of the form.
    
     * msid - Type: guid. Desc: the site of the request
     *
     * origin - Type: string. Desc: the clicked page component
     *
     * request_type - Type: string. Desc: Delete / Get request
     * @param {gdprUouSiteOwnerSelectRequestTypeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gdprUouSiteOwnerSelectRequestType = function (params) {
        return this.bi.log(__assign({ evid: 803 }, params));
    };
    /**
    * @typedef {Object} gdprUouSiteOwnerReturnedToPreviousFormStepParams
    * @property {string} from_step - where the user asked to return
    * @property {string} hashed_mail - hashed uou email
    * @property {string} hashed_phone - hashed uou phone
    * @property {GUID} msid - the site of the request
    * @property {string} origin - the clicked page component
    * @property {string} request_type - Delete / Get request
    **/
    /**
     * Name: GDPR - UoU - Site Owner Returned to Previous Form Step. Evid: 808.
     * Event description: The user click on 'back' /'cancel' button and returned to the previous from step.
    1st step-  choose request type
    2nd step - inserts uou information
    3rd step - re-confirm uou information.
    
     * from_step - Type: string. Desc: where the user asked to return
     *
     * hashed_mail - Type: string. Desc: hashed uou email
     *
     * hashed_phone - Type: string. Desc: hashed uou phone
     *
     * msid - Type: guid. Desc: the site of the request
     *
     * origin - Type: string. Desc: the clicked page component
     *
     * request_type - Type: string. Desc: Delete / Get request
     * @param {gdprUouSiteOwnerReturnedToPreviousFormStepParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gdprUouSiteOwnerReturnedToPreviousFormStep = function (params) {
        return this.bi.log(__assign({ evid: 808 }, params));
    };
    /**
    * @typedef {Object} gdprUouSiteOwnerUouRequestSubmissionSuccessParams
    * @property {GUID} gdpr_request_id - generated server request id
    * @property {string} hashed_mail - hashed uou email
    * @property {string} hashed_phone - hashed uou phone
    * @property {GUID} msid - the site of the request
    * @property {GUID} request_id - Deprecated
    * @property {string} request_type - Delete / Get request
    **/
    /**
     * Name: GDPR - UoU - Site Owner UoU Request Submission Success. Evid: 806.
     * Event description: The user/site owner request was successfully delivered to the server.
    
     * gdpr_request_id - Type: guid. Desc: generated server request id
     *
     * hashed_mail - Type: string. Desc: hashed uou email
     *
     * hashed_phone - Type: string. Desc: hashed uou phone
     *
     * msid - Type: guid. Desc: the site of the request
     *
     * request_id - Type: guid. Desc: Deprecated
     *
     * request_type - Type: string. Desc: Delete / Get request
     * @param {gdprUouSiteOwnerUouRequestSubmissionSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gdprUouSiteOwnerUouRequestSubmissionSuccess = function (params) {
        return this.bi.log(__assign({ evid: 806 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouSetUpAPrivacyPolicyClicksParams
    * @property {string} action - learn how / sub learn how / sub learn more
    **/
    /**
     * Name: Cookies banner UoU- Set up a privacy policy clicks. Evid: 1083.
     * Event description: User clicks on the options to learn more about the privacy policy.
    
     * action - Type: string. Desc: learn how / sub learn how / sub learn more
     * @param {cookiesBannerUouSetUpAPrivacyPolicyClicksParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouSetUpAPrivacyPolicyClicks = function (params) {
        return this.bi.log(__assign({ evid: 1083 }, params));
    };
    /**
    * @typedef {Object} gdprUouSiteOwnerWishToLearnMoreParams
    * @property {string} learn_more_type - Third-party apps/Wix code/GDPR
    * @property {GUID} msid - the site of the request
    * @property {string} origin - the clicked page component
    * @property {string} request_type - Delete / Get request
    **/
    /**
     * Name: GDPR - UoU - Site Owner Wish To Learn More. Evid: 809.
     * Event description: The user clicks on 'learn more' link on the request information text on the GDPR tab..
    
     * learn_more_type - Type: string. Desc: Third-party apps/Wix code/GDPR
     *
     * msid - Type: guid. Desc: the site of the request
     *
     * origin - Type: string. Desc: the clicked page component
     *
     * request_type - Type: string. Desc: Delete / Get request
     * @param {gdprUouSiteOwnerWishToLearnMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gdprUouSiteOwnerWishToLearnMore = function (params) {
        return this.bi.log(__assign({ evid: 809 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouAdvancedOptionsCtaParams
    * @property {string} action - customize cookies categories text /  customized cookie banner / reset your consent log
    **/
    /**
     * Name: Cookies banner UoU- Advanced options CTA. Evid: 1082.
     * Event description: User interaction with the advanced options.
    
     * action - Type: string. Desc: customize cookies categories text /  customized cookie banner / reset your consent log
     * @param {cookiesBannerUouAdvancedOptionsCtaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouAdvancedOptionsCta = function (params) {
        return this.bi.log(__assign({ evid: 1082 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouAPopUpIsDisplayParams
    * @property {string} pop_up_type - Privacy Policy link is missing / Reset cookie consent log / something went wrong / Cookie banner is published / Hide cookie banner / Your cookie policy is now live / Disable customized cookie banner / Enable wix standard cookie banner/  Disable wix standard cookie consent banner / sure you want to leave
    **/
    /**
     * Name: Cookies banner UoU- A pop up is display. Evid: 1090.
     * Event description: One of the different pop-ups is display.
    
     * pop_up_type - Type: string. Desc: Privacy Policy link is missing / Reset cookie consent log / something went wrong / Cookie banner is published / Hide cookie banner / Your cookie policy is now live / Disable customized cookie banner / Enable wix standard cookie banner/  Disable wix standard cookie consent banner / sure you want to leave
     * @param {cookiesBannerUouAPopUpIsDisplayParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouAPopUpIsDisplay = function (params) {
        return this.bi.log(__assign({ evid: 1090 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouUouDisableDataTransfersPopUpIsDisplayParams
    
    **/
    /**
     * Name: Cookies banner UoU- UoU 'disable data transfers?' pop-up is display. Evid: 1086.
     * Event description: UoU 'disable data transfers?  popup is displayed.
    
    
     * @param {cookiesBannerUouUouDisableDataTransfersPopUpIsDisplayParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouUouDisableDataTransfersPopUpIsDisplay = function (params) {
        return this.bi.log(__assign({ evid: 1086 }, params));
    };
    /**
    * @typedef {Object} gdprUsersUserSubmitTheGdprFormParams
    * @property {DateTime} account_creation_date - user information
    * @property {string} hashed_first_name - user information
    * @property {string} hashed_last_name - user information
    * @property {string} hashed_mail - email account that is visible to the user
    * @property {string} hashed_phone - user information
    * @property {boolean} is_file_loaded - user information
    * @property {boolean} is_premium - user information
    * @property {boolean} is_site_has_contact_form - user information
    * @property {DateTime} last_site_edit_date - user information
    * @property {string} request_type - Get / Delete
    * @property {string} site_contact_hashed_mail - user information
    * @property {Url} site_url - user information
    **/
    /**
     * Name: GDPR - Users - User Submit The GDPR Form. Evid: 811.
     * Event description: user GDPR form.
    
     * account_creation_date - Type: datetime. Desc: user information
     *
     * hashed_first_name - Type: string. Desc: user information
     *
     * hashed_last_name - Type: string. Desc: user information
     *
     * hashed_mail - Type: string. Desc: email account that is visible to the user
     *
     * hashed_phone - Type: string. Desc: user information
     *
     * is_file_loaded - Type: bool. Desc: user information
     *
     * is_premium - Type: bool. Desc: user information
     *
     * is_site_has_contact_form - Type: bool. Desc: user information
     *
     * last_site_edit_date - Type: datetime. Desc: user information
     *
     * request_type - Type: string. Desc: Get / Delete
     *
     * site_contact_hashed_mail - Type: string. Desc: user information
     *
     * site_url - Type: url. Desc: user information
     * @param {gdprUsersUserSubmitTheGdprFormParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gdprUsersUserSubmitTheGdprForm = function (params) {
        return this.bi.log(__assign({ evid: 811 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouUserClickedOnAdvancedOptionParams
    
    **/
    /**
     * Name: Cookies banner UoU- User clicked on Advanced option. Evid: 1078.
     * Event description: The user clicked to see the advanced cookie banner options.
    
    
     * @param {cookiesBannerUouUserClickedOnAdvancedOptionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouUserClickedOnAdvancedOption = function (params) {
        return this.bi.log(__assign({ evid: 1078 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouUouWithDisableDataTransfersPopUpParams
    * @property {string} action - close / disable transfers
    **/
    /**
     * Name: Cookies banner UoU- UoU with  'disable data transfers?' pop-up. Evid: 1087.
     * Event description: UoU interaction with the 'disable data transfers?' pop-up.
    
     * action - Type: string. Desc: close / disable transfers
     * @param {cookiesBannerUouUouWithDisableDataTransfersPopUpParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouUouWithDisableDataTransfersPopUp = function (params) {
        return this.bi.log(__assign({ evid: 1087 }, params));
    };
    /**
    * @typedef {Object} gdprUsersUserGdprFormSubmissionSuccessParams
    * @property {DateTime} account_creation_date - user information
    * @property {string} hashed_first_name - user information
    * @property {string} hashed_last_name - user information
    * @property {string} hashed_mail - email account that is visible to the user
    * @property {string} hashed_phone - user information
    * @property {boolean} is_file_loaded - user information
    * @property {boolean} is_premium - user information
    * @property {boolean} is_site_has_contact_form - user information
    * @property {DateTime} last_site_edit_date - user information
    * @property {GUID} request_id - server produce request id
    * @property {string} request_type - Get / Delete
    * @property {string} site_contact_hashed_mail - user information
    * @property {Url} site_url - user information
    * @property {GUID} ticket_id - answers ticket id
    **/
    /**
     * Name: GDPR - Users - User GDPR Form Submission Success. Evid: 812.
     * Event description: GDPR form submits successfully to the server and open support ticket.
    
     * account_creation_date - Type: datetime. Desc: user information
     *
     * hashed_first_name - Type: string. Desc: user information
     *
     * hashed_last_name - Type: string. Desc: user information
     *
     * hashed_mail - Type: string. Desc: email account that is visible to the user
     *
     * hashed_phone - Type: string. Desc: user information
     *
     * is_file_loaded - Type: bool. Desc: user information
     *
     * is_premium - Type: bool. Desc: user information
     *
     * is_site_has_contact_form - Type: bool. Desc: user information
     *
     * last_site_edit_date - Type: datetime. Desc: user information
     *
     * request_id - Type: guid. Desc: server produce request id
     *
     * request_type - Type: string. Desc: Get / Delete
     *
     * site_contact_hashed_mail - Type: string. Desc: user information
     *
     * site_url - Type: url. Desc: user information
     *
     * ticket_id - Type: guid. Desc: answers ticket id
     * @param {gdprUsersUserGdprFormSubmissionSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gdprUsersUserGdprFormSubmissionSuccess = function (params) {
        return this.bi.log(__assign({ evid: 812 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouDisplayCookieBannerOnSiteCtaParams
    * @property {boolean} toggle - on / off
    **/
    /**
     * Name: Cookies banner UoU- Display cookie banner on site CTA. Evid: 1077.
     * Event description: User interaction with the toggle to display the banner on his site.
    
     * toggle - Type: bool. Desc: on / off
     * @param {cookiesBannerUouDisplayCookieBannerOnSiteCtaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouDisplayCookieBannerOnSiteCta = function (params) {
        return this.bi.log(__assign({ evid: 1077 }, params));
    };
    /**
    * @typedef {Object} gdprUouSiteOwnerUouRequestSubmissionFailedParams
    * @property {string} error_reason - failure reason
    * @property {string} hashed_mail - hashed uou email
    * @property {string} hashed_phone - hashed uou phone
    * @property {GUID} msid - the site of the request
    * @property {string} origin - the clicked page component
    * @property {string} request_type - Delete / Get request
    **/
    /**
     * Name: GDPR - UoU - Site Owner UoU Request Submission Failed. Evid: 807.
     * Event description: The user/site owner request failed to deliver to the server (also after a retry ).
    
     * error_reason - Type: string. Desc: failure reason
     *
     * hashed_mail - Type: string. Desc: hashed uou email
     *
     * hashed_phone - Type: string. Desc: hashed uou phone
     *
     * msid - Type: guid. Desc: the site of the request
     *
     * origin - Type: string. Desc: the clicked page component
     *
     * request_type - Type: string. Desc: Delete / Get request
     * @param {gdprUouSiteOwnerUouRequestSubmissionFailedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gdprUouSiteOwnerUouRequestSubmissionFailed = function (params) {
        return this.bi.log(__assign({ evid: 807 }, params));
    };
    /**
    * @typedef {Object} gdprUouSiteOwnerInitiateGdprRequestParams
    * @property {GUID} msid - the site where the request asked
    * @property {string} origin - the clicked page component
    **/
    /**
     * Name: GDPR - UoU - Site Owner Initiate GDPR Request. Evid: 802.
     * Event description: The user / site owner click on the '+New Request' top left button or '+New Request' link on the text.
    
     * msid - Type: guid. Desc: the site where the request asked
     *
     * origin - Type: string. Desc: the clicked page component
     * @param {gdprUouSiteOwnerInitiateGdprRequestParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.gdprUouSiteOwnerInitiateGdprRequest = function (params) {
        return this.bi.log(__assign({ evid: 802 }, params));
    };
    /**
    * @typedef {Object} sampleEventTestParams
    
    **/
    /**
     * Name: sample event test. Evid: 800.
    
    
    
     * @param {sampleEventTestParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.sampleEventTest = function (params) {
        return this.bi.log(__assign({ evid: 800 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerSettingPageCtaParams
    * @property {string} action - toggle/save
    * @property {string} policy - cookie/ccpa
    * @property {boolean} toggle - (optional) on/off
    * @property {Url} url - url
    **/
    /**
     * Name: Cookies banner- setting page CTA. Evid: 817.
     * Event description: User interaction with the settings page.
    
     * action - Type: string. Desc: toggle/save
     *
     * policy - Type: string. Desc: cookie/ccpa
     *
     * toggle - Type: bool. Desc: (optional) on/off
     *
     * url - Type: url. Desc: url
     * @param {cookiesBannerSettingPageCtaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerSettingPageCta = function (params) {
        return this.bi.log(__assign({ evid: 817 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 5,
        endpoint: 'gdpr'
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map